const chunkMapping = {
	"webpack_container_remote_CHECKOUT_HcpSlice-webpack_container_remote_CHECKOUT_addressSlice": [
		77867,
		98328
	],
	"src_bootstrap_js-src_assets_images_loader_gif-node_modules_pure-react-carousel_dist_react-car-afe45b": [
		68266,
		94468,
		32307,
		12594,
		77127,
		85206,
		77216,
		99601,
		24253,
		48152,
		16422,
		78972,
		21228,
		17240,
		73882,
		20729,
		87949,
		9598,
		22756,
		76208,
		93421,
		16792,
		2813,
		86908,
		55077,
		42413,
		10497,
		84090,
		79144,
		66318,
		73913,
		72463,
		55169,
		93527,
		82013,
		15089,
		93894,
		75021
	],
	"src_components_PersonalizeMessageOption_index_js": [
		28602
	],
	"src_components_SearchResults_index_js": [
		61953
	],
	"src_components_ItemDetails_index_js": [
		94324
	],
	"src_components_MarketingMaterial_index_js": [
		78119
	],
	"src_components_ECheckOut_index_js": [
		32866
	],
	"src_components_TemplateDetail_index_js": [
		53075
	],
	"src_components_EmailDetail_index_js": [
		94044
	],
	"src_components_CheckOut_index_js": [
		97911
	],
	"src_components_OrderDetail_index_js": [
		99129
	],
	"src_components_TemplateSetup_index_js": [
		78464
	],
	"src_components_ManageStateShipWith_index_js": [
		37339
	],
	"src_components_Cart_index_js": [
		66227
	],
	"src_components_Collections_CreateCollection_index_js": [
		71198
	],
	"src_components_Collections_ModifyCollection_index_js": [
		87124
	],
	"src_components_Collections_index_js": [
		99103
	],
	"src_components_UserProfile_index_js": [
		30452
	],
	"src_components_SalesTeam_index_js": [
		14121
	],
	"src_components_AttributeSalesTeam_index_js": [
		36841
	],
	"src_components_OrderSearch_index_js": [
		32430
	],
	"src_components_shippingType_index_js": [
		41520
	],
	"src_components_UserRole_AllUserRoles_index_js": [
		6497
	],
	"src_components_UserRole_UserRoleDetail_index_js": [
		91326
	],
	"src_components_UserRole_CreateUserRole_index_js": [
		37073
	],
	"src_components_EmailManagement_index_js": [
		11396
	],
	"src_components_Account_index_js": [
		33209
	],
	"src_components_ProductDisplay_index_js": [
		26000
	],
	"src_components_UserSearch_index_js": [
		96276
	],
	"src_components_CreateUser_index_js": [
		76001
	],
	"src_components_ShipMethods_shipToHcp_js": [
		8736
	],
	"src_components_ShipMethods_shipToSite_js": [
		3702
	],
	"src_components_ShipMethods_shipToColleague_js": [
		99560
	],
	"src_components_ShipMethods_customizedResourceSharing_js": [
		52905
	],
	"src_components_ShipMethods_HcpCustomFeature_js": [
		89651
	],
	"src_components_AllocationEditsComp_index_js": [
		78452
	],
	"src_components_ShipMethods_ShipToDistribution_js": [
		13117
	],
	"src_components_ShipMethods_shipToRegulatedCustomer_js": [
		26388
	],
	"src_components_OrderDetailComp_index_js": [
		12053
	],
	"src_components_Support_index_js": [
		27017
	],
	"src_components_ValidForUse_index_js": [
		6876
	],
	"src_components_ViewAllTemplates_index_js": [
		44511
	],
	"src_components_SiteAdministration_index_js": [
		16862
	],
	"src_components_AddNewMessage_index_js": [
		39606
	],
	"src_components_AddressBook_index_js": [
		43345
	],
	"src_components_AddressBook_AddressBookCreateEdit_js": [
		38348
	],
	"src_components_ShippingMethodsAssignment_index_js": [
		46157
	],
	"webpack_container_remote_ItemDetails_CustomizeTemplates": [
		33057
	]
};
const idToExternalAndNameMapping = {
	"2813": [
		"default",
		"./trialAllocationApi",
		13223
	],
	"3702": [
		"default",
		"./ShipToSite",
		96411
	],
	"6497": [
		"default",
		"./UserRole",
		42791
	],
	"6876": [
		"default",
		"./ReportsComp",
		42791
	],
	"8736": [
		"default",
		"./ShipToHcp",
		96411
	],
	"9598": [
		"default",
		"./customResourceSharingApi",
		13223
	],
	"10497": [
		"default",
		"./announcementSlice",
		42791
	],
	"11396": [
		"default",
		"./EmailManagementComp",
		42791
	],
	"12053": [
		"default",
		"./OrderDetailInfo",
		96411
	],
	"12594": [
		"default",
		"./Hcp360Slice",
		96411
	],
	"13117": [
		"default",
		"./ShipToDistribution",
		96411
	],
	"14121": [
		"default",
		"./SalesTeamIndex",
		42791
	],
	"15089": [
		"default",
		"./userAllocationApi",
		42791
	],
	"16422": [
		"default",
		"./collectionApi",
		93847
	],
	"16792": [
		"default",
		"./templateDetailSlice",
		13223
	],
	"16862": [
		"default",
		"./SiteAdministrationComp",
		42791
	],
	"17240": [
		"default",
		"./cartSlice",
		67335
	],
	"20729": [
		"default",
		"./FooterComp",
		39169
	],
	"21228": [
		"default",
		"./api",
		67335
	],
	"22756": [
		"default",
		"./customResourceSharingSlice",
		13223
	],
	"24253": [
		"default",
		"./shipToDistributionSlice",
		96411
	],
	"26000": [
		"default",
		"./ProductDisplayComp",
		42791
	],
	"26388": [
		"default",
		"./ShipToRegulatedCustomer",
		96411
	],
	"27017": [
		"default",
		"./Support",
		42791
	],
	"28602": [
		"default",
		"./PersonalizeMessageOption",
		96411
	],
	"30452": [
		"default",
		"./UserProfileIndex",
		42791
	],
	"32307": [
		"default",
		"./ColleagueSlice",
		96411
	],
	"32430": [
		"default",
		"./OrderSearch",
		96411
	],
	"32866": [
		"default",
		"./ECheckoutComp",
		96411
	],
	"33057": [
		"default",
		"./CustomizeTemplates",
		13223
	],
	"33209": [
		"default",
		"./Account",
		42791
	],
	"36841": [
		"default",
		"./AttributeSalesTeamIndex",
		42791
	],
	"37073": [
		"default",
		"./UserRoleCreate",
		42791
	],
	"37339": [
		"default",
		"./ManageStateShipWithComp",
		42791
	],
	"38348": [
		"default",
		"./AddressBookCreateEdit",
		31791
	],
	"39606": [
		"default",
		"./AddStandardMessages",
		42791
	],
	"41520": [
		"default",
		"./ShippingType",
		96411
	],
	"42413": [
		"default",
		"./SalesTeamSliceIndex",
		42791
	],
	"43345": [
		"default",
		"./AddressBookComp",
		31791
	],
	"44511": [
		"default",
		"./ViewAllTemplatesComp",
		13223
	],
	"46157": [
		"default",
		"./ShippingMethodsAssignmentIndex",
		42791
	],
	"48152": [
		"default",
		"./shipToSiteSlice",
		96411
	],
	"52905": [
		"default",
		"./CustomizedResourceSharingComp",
		13223
	],
	"53075": [
		"default",
		"./TemplateDetailComp",
		13223
	],
	"55077": [
		"default",
		"./ReportsSlice",
		42791
	],
	"55169": [
		"default",
		"./supportSlice",
		42791
	],
	"61953": [
		"default",
		"./SearchResultsComp",
		95919
	],
	"66227": [
		"default",
		"./CartComp",
		67335
	],
	"66318": [
		"default",
		"./messagesSlice",
		42791
	],
	"68266": [
		"default",
		"./AddressBookSlice",
		31791
	],
	"71198": [
		"default",
		"./CreateCollection",
		93847
	],
	"72463": [
		"default",
		"./searchSliceUser",
		42791
	],
	"73882": [
		"default",
		"./orderSlice",
		67335
	],
	"73913": [
		"default",
		"./product",
		42791
	],
	"75021": [
		"default",
		"./userSearch",
		42791
	],
	"76001": [
		"default",
		"./CreateUser",
		42791
	],
	"76208": [
		"default",
		"./hcpSearchApi",
		13223
	],
	"77127": [
		"default",
		"./RegulatedCustomerSlice",
		96411
	],
	"77216": [
		"default",
		"./orderSearchSlice",
		96411
	],
	"77867": [
		"default",
		"./HcpSlice",
		96411
	],
	"78119": [
		"default",
		"./MarketingMaterialComp",
		13223
	],
	"78452": [
		"default",
		"./AllocationEditsComp",
		42791
	],
	"78464": [
		"default",
		"./TemplateSetupComp",
		42791
	],
	"78972": [
		"default",
		"./collectionSlice",
		93847
	],
	"79144": [
		"default",
		"./messagesApi",
		42791
	],
	"82013": [
		"default",
		"./user",
		42791
	],
	"84090": [
		"default",
		"./emailSlice",
		42791
	],
	"85206": [
		"default",
		"./ShippingTypeSlice",
		96411
	],
	"86908": [
		"default",
		"./SearchSlice",
		95919
	],
	"87124": [
		"default",
		"./CollectionModify",
		93847
	],
	"87949": [
		"default",
		"./HeaderComp",
		96921
	],
	"89651": [
		"default",
		"./HcpCustomFeatures",
		96411
	],
	"91326": [
		"default",
		"./UserRoleDetail",
		42791
	],
	"93421": [
		"default",
		"./itemDetailSlice",
		13223
	],
	"93527": [
		"default",
		"./trialAllocationApiUser",
		42791
	],
	"93894": [
		"default",
		"./userProfileSlice",
		42791
	],
	"94044": [
		"default",
		"./EmailDetailsComp",
		13223
	],
	"94324": [
		"default",
		"./ItemDetailComp",
		13223
	],
	"94468": [
		"default",
		"./CheckoutSlice",
		96411
	],
	"96276": [
		"default",
		"./UserSearchComp",
		42791
	],
	"97911": [
		"default",
		"./CheckoutComp",
		96411
	],
	"98328": [
		"default",
		"./addressSlice",
		96411
	],
	"99103": [
		"default",
		"./CollectionComp",
		93847
	],
	"99129": [
		"default",
		"./OrderDetail",
		96411
	],
	"99560": [
		"default",
		"./ShipToColleague",
		96411
	],
	"99601": [
		"default",
		"./personalizeMessageSlice",
		96411
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}